import { ACCENT, ACCENT_TEXT, TEXT_PRIMARY, TEXT_MUTED } from '../lib/medievalTheme';
import { trophyRankLabel, trophyTitle, trophyRecord } from '../utils/arena/trophies';
import TrophyBadge from './TrophyBadge';
import { t } from '../localization/t';

// Trophies tab of the profile overlay: one plaque per honour, newest
// first as the server orders them. Reads the overlay's `--vh-accent-*`
// palette through the ACCENT tokens like every other gold on the page.
export default function ProfileTrophies({ trophies }) {
  if (!trophies?.length) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center gap-2 text-center" style={{ color: TEXT_MUTED }}>
        <TrophyGlyph />
        <div className="text-[0.75cqw] italic">{t('No trophies yet')}</div>
        <div className="text-[0.625cqw]">{t('Finish a ranked season on the podium to earn one.')}</div>
      </div>
    );
  }
  return (
    <div
      className="flex-1 min-h-0 overflow-y-auto grid gap-3 auto-rows-min"
      style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(9.5cqw, 1fr))' }}
    >
      {trophies.map((trophy) => (
        <TrophyPlaque key={`${trophy.kind}-${trophy.seasonId}`} trophy={trophy} />
      ))}
    </div>
  );
}

function TrophyPlaque({ trophy }) {
  const record = trophyRecord(trophy);
  const champion = trophy.rank === 1;
  return (
    <div
      className="flex flex-col items-center text-center gap-1 px-2 pt-4 pb-3"
      style={{
        background: 'rgba(0,0,0,0.3)',
        border: `1px solid ${ACCENT} ${champion ? 0.45 : 0.18})`,
        borderRadius: 'var(--radius-md)',
      }}
    >
      <TrophyBadge rank={trophy.rank} size="5.5cqw" className="mb-2" />
      <span className="truncate max-w-full text-[0.8125cqw] font-semibold" style={{ color: TEXT_PRIMARY }}>
        {trophyTitle(trophy)}
      </span>
      <span className="text-[0.6875cqw] font-medium" style={{ color: champion ? ACCENT_TEXT : TEXT_PRIMARY }}>
        {t(trophyRankLabel(trophy.rank))}
      </span>
      {record ? (
        <span className="text-[0.5625cqw] tabular-nums" style={{ color: TEXT_MUTED }}>{record}</span>
      ) : null}
    </div>
  );
}

function TrophyGlyph() {
  return (
    <svg style={{ width: '2cqw', height: '2cqw', opacity: 0.4 }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4z" />
      <path d="M7 6H4v2a3 3 0 0 0 3 3M17 6h3v2a3 3 0 0 1-3 3" />
    </svg>
  );
}
